import { render, staticRenderFns } from "./DecadeTabs.vue?vue&type=template&id=11e54e2e&scoped=true&"
import script from "./DecadeTabs.vue?vue&type=script&lang=js&"
export * from "./DecadeTabs.vue?vue&type=script&lang=js&"
import style0 from "./DecadeTabs.vue?vue&type=style&index=0&id=11e54e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e54e2e",
  null
  
)

export default component.exports